// extracted by mini-css-extract-plugin
export var button = "homepageKbosKaiTemp-module--button--a529e";
export var content = "homepageKbosKaiTemp-module--content--8d401";
export var eyebrow = "homepageKbosKaiTemp-module--eyebrow--a1db0";
export var eyebrowIcon = "homepageKbosKaiTemp-module--eyebrowIcon--1f6cf";
export var headline = "homepageKbosKaiTemp-module--headline--42f4c";
export var homepageKbosKaiTemp = "homepageKbosKaiTemp-module--homepageKbosKaiTemp--84cb9";
export var rive = "homepageKbosKaiTemp-module--rive--54eee";
export var riveContainer = "homepageKbosKaiTemp-module--riveContainer--972db";
export var steps = "homepageKbosKaiTemp-module--steps--8fbfb";